export const CustomViewTypeEnum = {
  cases: 'cases',
  checks: 'checks',
  companies: 'companies',
  individuals: 'individuals',
} as const;
export type CustomViewTypeEnum =
  (typeof CustomViewTypeEnum)[keyof typeof CustomViewTypeEnum];
